// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.UndoMarkPaymentAsPaidOfflineWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline } from '@zg-rentals/ts-rent-payment-client';

import type { UndoMarkPaymentAsPaidOfflineWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline_Args {
  postData: UndoMarkPaymentAsPaidOfflineWebApiRequestDto;
}

export type UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline_Options = UseMutationOptions<
  void,
  unknown,
  UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline_Args
>;

/**
 * Undo a rent payment previously marked as received offline by the landlord
 */
export const useUndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline = ({
  httpClient,
  ...options
}: Omit<UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline_Args) =>
      UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline(args.postData, httpClient),
  });
};
